import { render, staticRenderFns } from "./DevolucaoOpmeConsignado.vue?vue&type=template&id=b5b6221e&"
import script from "./DevolucaoOpmeConsignado.vue?vue&type=script&lang=js&"
export * from "./DevolucaoOpmeConsignado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports